import React, { PureComponent, Fragment } from 'react';
import Plot from 'react-plotly.js';
import moment from 'moment';

import { splitArray, textTruncate } from '../utils/data-parser';

function reverseDateDisplay(inDate) {
  let dtList = inDate.split('-');
  let outData = dtList.reverse().reduce((a, b) => a + '-' + b);
  return outData;
}

const boxWidthX = 0.011;
const boxWidthY = 0.05;

export default class ProgressGraph extends PureComponent {
  constructor() {
    super();
    this.state = {
      processedData: null,
      dtJoined: null,
      dtCompleted: null,
    };
  }
  componentDidMount() {
    const { data } = this.props;
    let dtJoined = data.started_on;
    let dtCompleted = data.completed_on;
    let chapterData = {
      offset: [],
      x: [],
      y: [],
      score: [],
    };
    Object.values(data.chapters_attempted).forEach(chp => {
      let accuracy;
      if (chp.status === 'IN_PROGRESS') {
        accuracy = -2.0;
      } else if (chp.status === 'ASSESSMENT_UNAVAILABLE') {
        accuracy = -1.0; //Assessments Unavailable
      } else if (chp.status === 'ASSESSMENT_PENDING') {
        accuracy = -3.0; //Assessment Pending.
      } else if (chp.status === 'ASSESSMENT_COMPLETED') {
        accuracy = chp.accuracy;
      }
      chapterData['offset'].push(chp.started_on);
      chapterData['x'].push(chp.completed_on);
      chapterData['y'].push(textTruncate(chp.chapter_name, 24));
      chapterData['score'].push(accuracy);
    });
    console.log('componentDidMount', data, chapterData);
    this.setState({
      chapterData,
      dtJoined,
      dtCompleted,
    });
  }

  getColor(score) {
    if (score === -1.0) {
      return 'rgba(31,119,180, 0.6)';
    } else if (score === -2.0) {
      return 'rgba(221,221,221, 0.6)';
    } else if (score === -3.0) {
      return 'rgba(223,17,20, 0.6)';
    } else if (score >= 0.8) {
      return 'rgba(44,160,44, 0.6)';
    } else if (score > 0.5) {
      return 'rgba(188,189,34, 0.6)';
    } else {
      return 'rgba(250,218,94, 0.6)';
    }
  }

  getShapeList = () => {
    const shapes = [
      {
        line: {
          color: 'rgba(31,119,180, 0.9)',
          width: 0.03,
        },
        type: 'rect',
        fillcolor: 'rgba(31,119,180, 0.9)',
        xref: 'paper',
        yref: 'paper',
        x0: 0.07,
        x1: 0.07 + boxWidthX,
        y0: -0.25,
        y1: -0.25 + boxWidthY,
      },
      {
        line: {
          color: 'rgba(221,221,221, 0.9)',
          width: 0.03,
        },
        type: 'rect',
        fillcolor: 'rgba(221,221,221, 0.9)',
        xref: 'paper',
        yref: 'paper',
        x0: 0.22,
        x1: 0.22 + boxWidthX,
        y0: -0.25,
        y1: -0.25 + boxWidthY,
      },
      {
        line: {
          color: 'rgba(223,17,20, 0.9)',
          width: 0.03,
        },
        type: 'rect',
        fillcolor: 'rgba(223,17,20, 0.9)',
        xref: 'paper',
        yref: 'paper',
        x0: 0.29,
        x1: 0.29 + boxWidthX,
        y0: -0.25,
        y1: -0.25 + boxWidthY,
      },
      {
        line: {
          color: 'rgba(44,160,44, 0.9)',
          width: 0.03,
        },
        type: 'rect',
        fillcolor: 'rgba(44,160,44, 0.9)',
        xref: 'paper',
        yref: 'paper',
        x0: 0.42,
        x1: 0.42 + boxWidthX,
        y0: -0.25,
        y1: -0.25 + boxWidthY,
      },
      {
        line: {
          color: 'rgba(188,189,34, 0.9)',
          width: 0.03,
        },
        type: 'rect',
        fillcolor: 'rgba(188,189,34, 0.9)',
        xref: 'paper',
        yref: 'paper',
        x0: 0.52,
        x1: 0.52 + boxWidthX,
        y0: -0.25,
        y1: -0.25 + boxWidthY,
      },
      {
        line: {
          color: 'rgba(250,218,94, 0.9)',
          width: 0.03,
        },
        type: 'rect',
        fillcolor: 'rgba(250,218,94, 0.9)',
        xref: 'paper',
        yref: 'paper',
        x0: 0.62,
        x1: 0.62 + boxWidthX,
        y0: -0.25,
        y1: -0.25 + boxWidthY,
      },
    ];
    return shapes;
  };

  getAnnotationList = () => {
    const annotations = [
      {
        showarrow: false,
        yref: 'paper',
        xref: 'paper',
        x: 0.07 + boxWidthX,
        y: -0.25 + 0.5 * boxWidthY,
        text: 'No Assessment Available',
        font: {
          family: 'Arial, sans-serif',
          size: 13,
          color: '#7f7f7f',
        },
        xanchor: 'left',
        yanchor: 'middle',
      },
      {
        showarrow: false,
        yref: 'paper',
        xref: 'paper',
        x: 0.22 + boxWidthX,
        y: -0.25 + 0.5 * boxWidthY,
        text: 'In Progress',
        font: {
          family: 'Arial, sans-serif',
          size: 13,
          color: '#7f7f7f',
        },
        xanchor: 'left',
        yanchor: 'middle',
      },
      {
        showarrow: false,
        yref: 'paper',
        xref: 'paper',
        x: 0.29 + boxWidthX,
        y: -0.25 + 0.5 * boxWidthY,
        text: 'Assessment Pending',
        font: {
          family: 'Arial, sans-serif',
          size: 13,
          color: '#7f7f7f',
        },
        xanchor: 'left',
        yanchor: 'middle',
      },
      {
        showarrow: false,
        yref: 'paper',
        xref: 'paper',
        x: 0.42 + boxWidthX,
        y: -0.25 + 0.5 * boxWidthY,
        text: 'More than 80%',
        font: {
          family: 'Arial, sans-serif',
          size: 13,
          color: '#7f7f7f',
        },
        xanchor: 'left',
        yanchor: 'middle',
      },
      {
        showarrow: false,
        yref: 'paper',
        xref: 'paper',
        x: 0.52 + boxWidthX,
        y: -0.25 + 0.5 * boxWidthY,
        text: '50%-80%',
        font: {
          family: 'Arial, sans-serif',
          size: 13,
          color: '#7f7f7f',
        },
        xanchor: 'left',
        yanchor: 'middle',
      },
      {
        showarrow: false,
        yref: 'paper',
        xref: 'paper',
        x: 0.62 + boxWidthX,
        y: -0.25 + 0.5 * boxWidthY,
        text: 'Less than 50%',
        font: {
          family: 'Arial, sans-serif',
          size: 13,
          color: '#7f7f7f',
        },
        xanchor: 'left',
        yanchor: 'middle',
      },
    ];
    return annotations;
  };

  getDaysDiff = (past, future) => {
    var d1 = new Date(past);
    var d2 = new Date(future);
    var timeDiff = d2.getTime() - d1.getTime();
    var DaysDiff = timeDiff / (1000 * 3600 * 24);
    return DaysDiff;
  };

  render() {
    const { programCode } = this.props;
    const { chapterData, dtJoined, dtCompleted } = this.state;
    if (!chapterData) {
      return <div>No Data</div>;
    }
    return (
      <Fragment>
        <Plot
          data={[
            {
              x: chapterData.offset.map(off => this.getDaysDiff(dtJoined, off)),
              y: chapterData.y,
              orientation: 'h',
              marker: {
                color: 'rgba(200,208,21,0)',
                width: 1,
              },
              type: 'bar',
              text: chapterData.offset.map(off => reverseDateDisplay(off.split(' ')[0])),
              hoverinfo: 'y+text',
            },
            {
              x: chapterData.x.map((xData, i) =>
                this.getDaysDiff(chapterData.offset[i], xData ? xData : dtCompleted),
              ),
              text: chapterData.x.map(xData =>
                xData !== null
                  ? reverseDateDisplay(xData.split(' ')[0])
                  : reverseDateDisplay(dtCompleted.split(' ')[0]),
              ),

              y: chapterData.y,
              orientation: 'h',
              type: 'bar',
              hoverinfo: 'text',
              marker: {
                color: chapterData.score.map(scr => this.getColor(scr)),
                width: 1,
              },
            },
          ]}
          layout={{
            title: programCode + ' Progress',
            barmode: 'stack',
            margin: {
              l: 200,
              t: 80,
              b: 100,
              r: 100,
              autoexpand: true,
            },
            xaxis: {
              showgrid: false,
              showline: false,
              range: [0, this.getDaysDiff(dtJoined, dtCompleted)],
              tickvals: splitArray(0, this.getDaysDiff(dtJoined, dtCompleted), 10),
              ticktext: splitArray(0, this.getDaysDiff(dtJoined, dtCompleted), 10).map(
                dys => {
                  var dt = moment(dtJoined.split(' ')[0], 'YYYY-MM-DD');
                  dt.add(dys, 'days');
                  return moment(dt).format('DD-MM-YYYY');
                },
              ),
            },
            yaxis: {
              showgrid: false,
              showline: false,
            },
            showlegend: false,
            shapes: this.getShapeList(),
            annotations: this.getAnnotationList(),
          }}
        />
      </Fragment>
    );
  }
}
